<template>
    <div class="form-group">
        <label class="font-weight-bold">Test API Settings</label><br>
        <button class="btn btn-sm btn-light-primary" :disabled="apiTestOngoing" @click="testApiSettings">
            <i class="fas fa-arrow-right mr-1"/>
            Start test
        </button>
        <div class="mt-3 font-size-lg">
            <div v-if="apiTestOngoing">
                <Spinner class="d-inline-block"
                         :speed="0.6"
                         line-fg-color="#795BF3"
                         size="small"/>
                Connecting...
            </div>
            <div v-if="apiTestSucceeded === true" class="text-success">
                <i class="fas fa-check-circle"/>
                Connection successful
            </div>
            <div v-if="apiTestSucceeded === false" class="text-danger">
                <i class="fas fa-times-circle"/>
                Connection failed
            </div>
        </div>
    </div>
</template>

<script>
import Spinner from "vue-simple-spinner";

export default {
    components: {
        Spinner
    },

    props: {
        configs: Object
    },

    data() {
        return {
            apiTestOngoing: false,
            apiTestSucceeded: null
        }
    },

    methods: {
        testApiSettings() {
            this.apiTestSucceeded = null;
            this.apiTestOngoing = true;

            axios.post(this.$route('integrations.MAUVE.test'), {
                user: this.configs.mauve_api_user,
                password: this.configs.mauve_api_pw,
            }).then(response => {
                this.apiTestSucceeded = response.data.success;
                this.apiTestOngoing = false;
            }).catch(errorResponse => {
                this.apiTestSucceeded = false;
                this.apiTestOngoing = false;
            })
        }
    }
}
</script>
